import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.find.js";
import { dbDataHandle } from '@/store/function/common/index';
import { getPerformantRateApi } from '@/api';

import downloadCsv from 'download-csv';
export default {
  name: 'PR',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      prData: [],
      tableField: [{
        key: 'date',
        label: '月份'
      }, {
        key: 'PRGoal',
        label: '目標 PR 值 (%)'
      }, {
        key: 'PRActual',
        label: '實際 PR 值 (%)'
      }, {
        key: 'guaranteePr',
        label: '保證 PR 值 (%)'
      }, {
        key: 'yearPRGoal',
        label: '年度目標值 (%)'
      }, {
        key: 'accPRAll',
        label: '累積實際值 (%)'
      }, {
        key: 'accGuaranteePr',
        label: '(區間) 累積保證值 (%)'
      }],
      dataClassArr: ['目標 PR 值 (%)', '實際 PR 值 (%)', '保證 PR 值 (%)', '年度目標值 (%)', '累積實際值 (%)', '(區間) 累積保證值 (%)'],
      dataClass: ['目標 PR 值 (%)', '實際 PR 值 (%)', '保證 PR 值 (%)', '年度目標值 (%)', '累積實際值 (%)', '(區間) 累積保證值 (%)'],
      PrAnalysisChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: 'PR值 (%)'
          }
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(255, 192, 0)',
          type: 'column',
          name: '目標 PR 值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(124,181,236)',
          type: 'column',
          name: '實際 PR 值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(31, 209, 150)',
          type: 'column',
          name: '保證 PR 值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(255, 162, 0)',
          name: '年度目標值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(86, 160, 232)',
          name: '累積實際值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }, {
          color: 'rgb(2, 181, 122)',
          name: '(區間) 累積保證值 (%)',
          data: [],
          yAxis: 0,
          visible: true
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      prDataForExcel: []
    };
  },
  methods: {
    getPrData: function getPrData(months) {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _prData$data, prData;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.PrAnalysisChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context.prev = 1;
                _context.next = 4;
                return getPerformantRateApi(_this.$route.query.fid, _this.$route.query.siteName + '.json', months);
              case 4:
                prData = _context.sent;
                if (prData !== null && prData !== void 0 && (_prData$data = prData.data) !== null && _prData$data !== void 0 && _prData$data.success) {
                  // 複製 prData、prDataForExcel 不能 refer 同個 data
                  // renderData() 會改動 prData 資料

                  // 下載資料用
                  _this.prDataForExcel = prData.data.data;

                  // 顯示圖表、表格用，copy 避免改動到 rawData (etodayData.data.data)
                  _this.prData = prData.data.data.map(function (item) {
                    var copy = Object.assign({}, item);
                    return copy;
                  });
                  _this.renderData();
                  _this.hasNoData = false;
                }
                _context.next = 13;
                break;
              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);
                console.log('getPrData error: ', _context.t0);
                _this.hasNoData = true;
                _context.t0.msg && _this.$swal(_context.t0.msg);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 8]]);
      }))();
    },
    renderData: function renderData() {
      var _this2 = this;
      this.PrAnalysisChart.xAxis.categories = [];
      this.PrAnalysisChart.series.forEach(function (x) {
        x.data = [];
      });
      this.prData.forEach(function (x) {
        _this2.PrAnalysisChart.xAxis.categories.push(x.date);
        // 圖表、表格 是共用 this.prData 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.PRGoal = x.PRGoal === null ? null : dbDataHandle(x.PRGoal);
        x.PRActual = x.PRActual === null ? null : dbDataHandle(x.PRActual * 100);
        // x.PRActual = x.PRActual === null ? null : dbDataHandle(x.PRActual * 100) > 100 ? 100 : dbDataHandle(x.PRActual * 100)
        x.guaranteePr = x.guaranteePr === null ? null : dbDataHandle(x.guaranteePr);
        x.yearPRGoal = x.yearPRGoal === null ? null : dbDataHandle(x.yearPRGoal);
        x.accPRAll = x.accPRAll === null ? null : dbDataHandle(x.accPRAll * 100);
        x.accGuaranteePr = x.accGuaranteePr === null ? null : dbDataHandle(x.accGuaranteePr);
        _this2.PrAnalysisChart.series[0].data.push(x.PRGoal);
        _this2.PrAnalysisChart.series[1].data.push(x.PRActual);
        _this2.PrAnalysisChart.series[2].data.push(x.guaranteePr);
        _this2.PrAnalysisChart.series[3].data.push(x.yearPRGoal);
        _this2.PrAnalysisChart.series[4].data.push(x.accPRAll);
        _this2.PrAnalysisChart.series[5].data.push(x.accGuaranteePr);
      });
      this.hideHighChartLoading();
      // this.avgPR()
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
          this.PrAnalysisChart.chart.events = {};
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.PrAnalysisChart.xAxis.categories);
      this.PrAnalysisChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.PrAnalysisChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.prDataForExcel.forEach(function (obj) {
        var PRGoal = obj.PRGoal === null ? null : obj.PRGoal;
        var PRActual = obj.PRActual === null ? null : obj.PRActual * 100;
        var guaranteePr = obj.guaranteePr === null ? null : obj.guaranteePr;
        var yearPRGoal = obj.yearPRGoal === null ? null : obj.yearPRGoal;
        var accPRAll = obj.accPRAll === null ? null : obj.accPRAll * 100;
        var accGuaranteePr = obj.accGuaranteePr === null ? null : obj.accGuaranteePr;
        download[0].data.push(PRGoal);
        download[1].data.push(PRActual);
        download[2].data.push(guaranteePr);
        download[3].data.push(yearPRGoal);
        download[4].data.push(accPRAll);
        download[5].data.push(accGuaranteePr);
      });
      this.PrAnalysisChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    },
    avgPR: function avgPR() {
      var _this3 = this;
      this.PrAnalysisChart.series[3].data = [];
      var num = 0;
      this.PrAnalysisChart.series[1].data.forEach(function (x, idx) {
        num = num + x;
        var avg = dbDataHandle(num / (idx + 1));
        _this3.PrAnalysisChart.series[3].data.push(avg);
      });
    }
  },
  watch: {
    dataClassArr: function dataClassArr(newValue, oldValue) {
      var _this4 = this;
      var setData = [{
        name: '目標 PR 值 (%)',
        dataName: ['目標 PR 值 (%)']
      }, {
        name: '實際 PR 值 (%)',
        dataName: ['實際 PR 值 (%)']
      }, {
        name: '保證 PR 值 (%)',
        dataName: ['保證 PR 值 (%)']
      }, {
        name: '年度目標值 (%)',
        dataName: ['年度目標值 (%)']
      }, {
        name: '累積實際值 (%)',
        dataName: ['累積實際值 (%)']
      }, {
        name: '(區間) 累積保證值 (%)',
        dataName: ['(區間) 累積保證值 (%)']
      }];
      if (oldValue !== newValue) {
        this.PrAnalysisChart.series.forEach(function (x) {
          x.visible = false;
        });
        setData.forEach(function (x) {
          if (newValue.includes(x.name)) {
            x.dataName.forEach(function (y) {
              _this4.PrAnalysisChart.series.find(function (z) {
                return z.name === y;
              }).visible = true;
            });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this5.avgPR();
            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }
};